import { HttpContextToken } from '@angular/common/http';

export const SUPPRESS_NETWORK_ERRORS = new HttpContextToken<boolean>(
    () => false,
);
